/* eslint-disable */
import apiClient from '@u/apiClient'
import FetchAgendaEventsController from '@/wayfinder/actions/App/Http/Controllers/Agenda/FetchAgendaEventsController'
import FetchUnplannedEventsController from '@/wayfinder/actions/App/Http/Controllers/Agenda/FetchUnplannedEventsController'
import UpdateEventTimeController from '@/wayfinder/actions/App/Http/Controllers/Agenda/UpdateEventTimeController'
import GetEventByIdController from '@/wayfinder/actions/App/Http/Controllers/Agenda/GetEventByIdController'
import StoreEventController from '@/wayfinder/actions/App/Http/Controllers/Agenda/StoreEventController'
import UpdateEventAgendaController from '@/wayfinder/actions/App/Http/Controllers/Agenda/UpdateEventAgendaController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

let base_error = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  //region fetch
  async fetchEvents({ commit, getters }, payload) {
    await apiClient
      .route(FetchAgendaEventsController.post(), payload)
      .then(async (response) => {
        if (response.data) {
          await commit('setEvents', response.data.events)
          await commit('setEventsUnplanned', response.data.unPlanned)
        }
      })
      .catch(async (reason) => {
        console.error('fetchEvents', reason)
      })
  },
  async fetchUnplannedEvents({ commit, getters }) {
    await apiClient
      .route(FetchUnplannedEventsController.post())
      .then(async (response) => {
        // console.log('res', response)
        if (response.data) {
          // await commit('setEvents', response.data.events)
          await commit('setEventsUnplanned', response.data.unPlanned)
        }
      })
      .catch(async (reason) => {
        console.error('fetchEvents', reason)
      })
  },

  //endregion

  async updateEventByDrag({ commit }, obj) {
    await apiClient
      .route(UpdateEventTimeController.put({ event: obj.id }), obj)
      .then(async (response) => {
        commit('updateEventInList', response.data)
        processSuccessCallback(obj)
      })
      .catch(async (reason) => {
        console.error('updateEventByDrag', reason)
      })
  },

  async fetchEventById({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .route(GetEventByIdController.get({ event: payload.event_id }))
      .then(async (response) => {
        await commit('setEvent', response.data.event)
        await commit('setEventMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchEventById', reason)
      })
  },

  async fetchNewEvent({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })

    await apiClient
      .route(GetNewModelController.get({ query: { model: 'event' } }))
      .then(async (response) => {
        await commit('setEvent', response.data.event)
        await commit('setEventMetadata', response.data.metadata)
        if (payload.from) commit('setEventDateFrom', payload.from)
        if (payload.to) commit('setEventDateTo', payload.to)
        if (payload.full_day) commit('setEventFullDay', payload.full_day)
        if (payload.type)
          commit('alterEvent', { attribute: 'type', value: payload.type })
        if (payload.dossier) commit('setEventDossier', payload.dossier)
      })
      .catch(async (reason) => {
        console.error('fetchNewEvent', reason)
      })
  },
  fetchLinkForOutlook({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .get(
          `/api/planning/ical/${payload.type}/${payload.dashboard}/${payload.start}/${payload.end}/calendars`
        )
        .then((response) => {
          console.log(response)
          resolve(response.data)
        })
        .catch(async (reason) => {
          console.error('fetchNewEvent', reason)
        })
    })
  },

  async postEvent({ commit }, obj) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .route(StoreEventController.post(), obj.event)
      .then(async (response) => {
        // console.log("response", response)
        if (response.status === 200) {
          if (obj.successCallback) {
            await obj.successCallback(response.data.event)
          }
        }
      })
      .catch(async (reason) => {
        console.error('postEvent', reason)
      })
  },

  async updateEvent({ commit }, obj) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .route(
        UpdateEventAgendaController.put({ event: obj.event.id }),
        obj.event
      )
      .then(async (response) => {
        // console.log('response', response)
        if (response.status === 200) {
          commit('setEvent', response.data.event)
          if (obj.successCallback) {
            await obj.successCallback(response.data.event)
          }
        }
      })
      .catch(async (reason) => {
        console.error('updateEvent', reason)
      })
  },
  async deleteEventById({ commit }, payload) {
    await apiClient
      .delete(`/api/event/${payload.id}`)
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteEventById', reason)
      })
  },
  async undoDeleteEventById({ commit }, payload) {
    await apiClient
      .get(`/api/event/undo-delete/${payload.id}`)
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteEventById', reason)
      })
  },

  fetchEventById2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetEventByIdController.get({ event: payload.event_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async refreshEventTasksInList({ commit }, { event_id }) {
    await apiClient
      .route(GetEventByIdController.get({ event: event_id }))
      .then(async (response) => {
        if (response.data?.event?.tasks !== undefined) {
          commit('setEventTasksInList', {
            event_id,
            tasks: response.data.event.tasks
          })
        }
      })
      .catch(async (reason) => {
        console.error('refreshEventTasksInList', reason)
      })
  }
  // async fetchEventDisponbilitiesByOption({ commit }, payload) {
  //   console.log('payload', payload)
  //   await apiClient
  //     .get(`agenda/fetch-timeslots`, { params: payload.params })
  //     .then(async (response) => {
  //       // await commit('setEventDisponibilities', response.data.timeslots
  //       if ('index' in payload) {
  //         //  commit('work/setEventTimeSlotInWorkEvent', {index: payload.index, timeslots: response.data.timeslots})
  //       }
  //       else {
  //         commit('setEventTimeSlotInEvent', response.data.timeslots)
  //       }
  //     })
  //     .catch(async (reason) => {
  //       await console.error('fetchEventDisponbilitiesByOption', reason)
  //     })
  // }
}
